import React, { useState } from "react";

const NowPlaying = ({ nowPlaying }) => {
    const [isMinimized, setIsMinimized] = useState(false);

    return (
        <div className={`now-playing-popup${isMinimized ? " minimized" : ""}`}>
            <div className="now-playing-header">
                <span className="now-playing-title">Now Playing</span>
                <button
                    type="button"
                    className="now-playing-toggle"
                    onClick={() => setIsMinimized((prev) => !prev)}
                    aria-expanded={!isMinimized}
                    aria-label={isMinimized ? "Restore now playing panel" : "Minimize now playing panel"}
                >
                    {isMinimized ? "+" : "-"}
                </button>
            </div>

            {!isMinimized && (
                <>
                    <img
                        src={nowPlaying && nowPlaying.cover ? nowPlaying.cover : "https://rjbogz.com/records/default.png"}
                        alt={nowPlaying && nowPlaying.album ? nowPlaying.album : "Unknown Album"}
                    />
                    <div className="details">
                        <h3>{nowPlaying && nowPlaying.album ? nowPlaying.album : "Unknown Album"}</h3>
                        <p>{nowPlaying && nowPlaying.artist ? nowPlaying.artist : "Unknown Artist"}</p>
                        <audio controls className="audio-player">
                            <source
                                src={nowPlaying && nowPlaying.streamUrl ? nowPlaying.streamUrl : ""}
                                type="audio/mpeg"
                            />
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                </>
            )}
        </div>
    );
};

export default NowPlaying;
